// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/special-c-of-a.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/special-c-of-a/flight-authority-types.js';
import g1 from '../lessons/air-law/special-c-of-a/special-c-of-a.js';

mount([g0, g1]);
